import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"

export const LineItems_s = styled.div` 
  height: calc(100vh - 155px);
  overflow: auto !important;
  position: fixed; 
  width: 100%; 
  
  .p-paginator {
    bottom: 0px;
    .p-connected-overlay-enter-done { background: white; }
  }
  .line-items-table-container {
    height: 100%;
  }
  #line-items-table {
    height: 100%;
  }
  .p-datatable-scrollable-wrapper {
    height: 100%;
  }
  .p-datatable-scrollable-view {
    min-height: calc(100% + 250px);
  }
  .p-datatable-scrollable-body {
    height: 100%;
    padding-bottom: 250px;
  }
`

export const LineItemsTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  height: 100%; 
  padding-bottom: 0 !important;

  .p-datatable-scrollable-view.p-datatable-frozen-view .p-datatable-scrollable-header-table {
    width: 475px;
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  .account-number .p-dropdown-items-wrapper {
    max-height: 200px;
    overflow: auto;
  }
`

export const PercentTenantRevenue_s = styled.div`
  .p-dropdown {
    width: 285px;
  }
`